import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
import { Password } from "primereact/password";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { getAllActivityGroup } from "../../../../Services/MiniApisService";
import { saveIncentivePaymentDetail } from "../../../../Services/IncentiveDetails";
import "primeflex/primeflex.css";

function PaymentDetailsDialog({
  visible,
  formData,
  handleChange,
  isFormValid,
  resetForm,
  setShowPaymentPopup,
  popupYearOptions,
  popupMonthOptions,
  selectedLanguageId,
  areaId,
}) {
  const [activityGroupOptions, setActivityGroupOptions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    const payload = {
      year: formData.popupYear,
      month: formData.popupMonth,
      remark: formData.remark,
      password: formData.password,
      activityType: formData.dropdown2,
      activityFor: formData.regionDropdown,
    };
    try {
      setIsSubmitting(true);
      await saveIncentivePaymentDetail(payload, selectedLanguageId, areaId);
      resetForm();
      setShowPaymentPopup(false);
    } catch (error) {
      console.error("Failed to save payment detail:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (!visible) return;
    const fetchActivityGroups = async () => {
      try {
        const data = await getAllActivityGroup(selectedLanguageId, areaId);
        setActivityGroupOptions(data || []);
      } catch (error) {
        console.error("Failed to fetch activity groups:", error);
      }
    };
    fetchActivityGroups();
  }, [visible, selectedLanguageId, areaId]);
  return (
    <Dialog
      header="Payment Details"
      visible={visible}
      style={{ width: "1250px" }}
      modal
      onHide={() => {
        resetForm();
        setShowPaymentPopup(false);
      }}
    >
      <div className="p-fluid">

        <div className="grid">
          <div className="col-12 md:col-6">
            <div className="field">
              <label>Activity Group *</label>
              <MultiSelect
                value={formData.dropdown2}
                options={activityGroupOptions}
                onChange={(e) => handleChange("dropdown2", e.value)}
                placeholder="Select options"
                className={!formData.dropdown2?.length ? "p-invalid" : ""}
              />
            </div>
          </div>

          <div className="col-12 md:col-6">
            <div className="field">
              <label>Year *</label>
              <Dropdown
                value={formData.popupYear}
                options={popupYearOptions}
                onChange={(e) => handleChange("popupYear", e.value)}
                placeholder="Select Year"
                className={!formData.popupYear ? "p-invalid w-full" : "w-full"}
              />
            </div>
          </div>
        </div>

        <div className="grid">
          <div className="col-12 md:col-6">
            <div className="field">
              <label>Month *</label>
              <Dropdown
                value={formData.popupMonth}
                options={popupMonthOptions}
                onChange={(e) => handleChange("popupMonth", e.value)}
                placeholder="Select Month"
                className={!formData.popupMonth ? "p-invalid w-full" : "w-full"}
              />
            </div>
          </div>

          <div className="col-12 md:col-6">
            <div className="field">
              <label>Region *</label>
              <MultiSelect
                value={formData.regionDropdown}
                options={[
                  { label: "State", value: "state" },
                  { label: "Central", value: "central" }
                ]}
                onChange={(e) => handleChange("regionDropdown", e.value)}
                placeholder="Select options"
                className={!formData.regionDropdown?.length ? "p-invalid" : ""}
              />
            </div>
          </div>
        </div>

        <div className="grid">
          <div className="col-12 md:col-6">
            <div className="field">
              <label>Password *</label>
              <Password
                value={formData.password}
                onChange={(e) => handleChange("password", e.target.value)}
                toggleMask
                feedback={false}
                className={!formData.password ? "p-invalid w-full" : "w-full"}
              />
            </div>
          </div>

          <div className="col-12 md:col-6">
            <div className="field">
              <label>Remark *</label>
              <InputTextarea
                value={formData.remark}
                onChange={(e) => handleChange("remark", e.target.value)}
                rows={3}
                autoResize
                className={!formData.remark ? "p-invalid w-full" : "w-full"}
              />
            </div>
          </div>
        </div>

        <div className="flex justify-content-end mt-3">
          <Button
            label="Submit"
            disabled={!isFormValid() || isSubmitting}
            loading={isSubmitting}
            onClick={handleSubmit}
          />
        </div>

      </div>
    </Dialog>
  );
}

export default PaymentDetailsDialog;